// extracted by mini-css-extract-plugin
export default {"container":"Address_container__IrDb2","address":"Address_address__XSMxM","headerTitle":"Address_headerTitle__iYS1r"};